import { useLocation } from 'react-router-dom';
import { ForceTheme } from 'src/common/components/force-theme';
import { ThemeColorMode } from 'src/common/enums';
import { useGetUserQuery } from 'src/common/slices';
import { useActiveCampaign } from 'src/features/campaigns/hooks/use-active-campaign';
import { SubscribeNowLabel, useTrackSubscribeNow } from 'src/features/campaigns/hooks/use-track-subscribe-now';
import { Countdown } from '../../components/countdown';
import { useSubscribeNowCtaLink } from '../../hooks/use-subscribe-now-cta-link';
import { useCampaignCta } from '../hooks';
import { SubscribeButton } from '../subscribe-button';
import { ButtonWrapper, LeftRays, LeftStars, RightStars, StyledBar, StyledText, StyledTitle, StyledWrapRow } from './top-bar.styles';
import type { TicketingEventCampaignTopBarProps } from './top-bar.types';
export const TicketingEventCampaignTopBar = ({
  hideCTA
}: TicketingEventCampaignTopBarProps) => {
  const trackSubscribeNow = useTrackSubscribeNow();
  const {
    pathname
  } = useLocation();
  const userQuery = useGetUserQuery();
  const {
    campaign
  } = useActiveCampaign();
  const ctaText = useCampaignCta(campaign);
  const urlToNavigate = useSubscribeNowCtaLink(campaign);
  const onCtaClick = () => trackSubscribeNow(SubscribeNowLabel.FlashSaleTopBar);
  if (!campaign) return null;
  const isAnonymous = !userQuery?.data?.data?.user;
  const isHack2WinPage = pathname.includes('/hack2win');
  return <ForceTheme themeMode={ThemeColorMode.DARK} data-sentry-element="ForceTheme" data-sentry-component="TicketingEventCampaignTopBar" data-sentry-source-file="top-bar.tsx">
      <StyledBar data-testid="campaign-bar" data-sentry-element="StyledBar" data-sentry-source-file="top-bar.tsx">
        <LeftRays data-sentry-element="LeftRays" data-sentry-source-file="top-bar.tsx" />
        <LeftStars data-sentry-element="LeftStars" data-sentry-source-file="top-bar.tsx" />
        <RightStars data-sentry-element="RightStars" data-sentry-source-file="top-bar.tsx" />
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="top-bar.tsx">
          <StyledTitle data-testid="campaign-top-bar-text" data-sentry-element="StyledTitle" data-sentry-source-file="top-bar.tsx">
            <StyledText data-sentry-element="StyledText" data-sentry-source-file="top-bar.tsx">
              {isAnonymous || isHack2WinPage ? <>
                  SAVE BIG: <span>{campaign.amount}%</span> on annual subscriptions!
                </> : <>
                  Save <span>{campaign.amount}%</span> on annual subscriptions & get <span>3 tickets</span> per room!
                </>}
            </StyledText>
          </StyledTitle>
        </StyledWrapRow>
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="top-bar.tsx">
          {!hideCTA && !isHack2WinPage && <ButtonWrapper>
              <SubscribeButton to={urlToNavigate} onClick={onCtaClick}>
                {ctaText}
              </SubscribeButton>
            </ButtonWrapper>}
          <Countdown vertical dark endTime={campaign.endTime} data-sentry-element="Countdown" data-sentry-source-file="top-bar.tsx" />
        </StyledWrapRow>
      </StyledBar>
    </ForceTheme>;
};